<ng-container>
  <div class="wellcome" *ngIf="user$ | async as user">
    <div class="box-menu">
      <div class="label">
        <span>{{ user?.firstName }}</span>
        <span class="material-symbols-outlined fs-5">keyboard_arrow_down</span>
      </div>

      <div class="menu">
        <div class="menu-user">
          <span class="userName">{{ user?.firstName }} {{ user?.lastName }}</span>
          <div class="menu-email">
            <span class="email">Email: {{ user?.email }}</span>
            <span class="registration">ID: {{ user?.uid }}</span>
          </div>
        </div>

        <ul class="list">
          <li *ngFor="let link of links">
            <a href="#" (click)="onLinkClick($event, link)">
              {{ link.linkName }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>
